// frontend/src/components/ProfileEditor.js
import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../config';
// Убедитесь, что эти импорты НЕ нужны и удалены, если вы не создавали файлы
// import HintIcon from './HintIcon';
// import HintPopup from './HintPopup';
import './ProfileEditor.css'; // Подключаем стили

const ProfileEditor = ({ telegramId, userData, onProfileUpdated, onSectionChange }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Удаляем состояние successMessage
  // const [successMessage, setSuccessMessage] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false); // <-- Новое состояние для кнопки

  // --- Инициализация состояний ---
  const [links, setLinks] = useState([]);
  const [formData, setFormData] = useState({
    name: '', city: '', bio: '', avatar: '', principles: '',
    interests: '', development: '', resources: '', contact_goals: ''
  });
  const [presetAvatars, setPresetAvatars] = useState([]);
  const [loadingAvatars, setLoadingAvatars] = useState(true);
  const [errorAvatars, setErrorAvatars] = useState(null);
  const [showAvatarSelector, setShowAvatarSelector] = useState(false);
  const [avatarPreviewUrl, setAvatarPreviewUrl] = useState('');

  // --- Эффекты ---

  // Инициализация формы данными пользователя
   useEffect(() => {
     if (userData) {
       const userLinks = [];
       if (userData.links && Array.isArray(userData.links)) {
         userLinks.push(...userData.links.filter(link => link && link.trim() !== ''));
       } else { // Обратная совместимость
         if (userData.website) userLinks.push(userData.website);
         if (userData.instagram) userLinks.push(userData.instagram);
         // ... другие поля
       }
       if (userLinks.length === 0) userLinks.push('');
       setLinks(userLinks.slice(0, 5));

       setFormData({
         name: userData.name || '',
         city: userData.city || '',
         bio: userData.bio || '',
         avatar: userData.avatar || '',
         principles: userData.principles || '',
         interests: userData.interests || '',
         development: userData.development || '',
         resources: userData.resources || '',
         contact_goals: userData.contact_goals || ''
       });
       setAvatarPreviewUrl(userData.avatar || '');
     }
   }, [userData]);

  // Загрузка предустановленных аватаров
   useEffect(() => {
     const fetchPresetAvatars = async () => {
       setLoadingAvatars(true); setErrorAvatars(null);
       try {
         const response = await fetch(getApiUrl('/api/get_preset_avatars'));
         if (!response.ok) throw new Error(`Ошибка получения аватаров: ${response.status}`);
         const data = await response.json();
         setPresetAvatars(data.avatars && data.avatars.length > 0
           ? data.avatars
           : ['/avatars/01.jpg', '/avatars/02.jpg', '/avatars/03.jpg', '/avatars/04.jpg', '/avatars/05.jpg', '/avatars/06.jpg'] // Дефолт
         );
       } catch (err) { console.error("Ошибка при загрузке аватаров:", err); setErrorAvatars(err.message); setPresetAvatars(['/avatars/01.jpg', '/avatars/02.jpg', '/avatars/03.jpg', '/avatars/04.jpg', '/avatars/05.jpg', '/avatars/06.jpg']); } // Дефолт при ошибке
       finally { setLoadingAvatars(false); }
     };
     fetchPresetAvatars();
   }, []);

  // --- Обработчики ---

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

   const handleLinkChange = (index, value) => { const newLinks = [...links]; newLinks[index] = value; setLinks(newLinks); };
   const addLinkField = () => { if (links.length < 5) setLinks([...links, '']); };
   const removeLinkField = (index) => { if (links.length > 1) setLinks(links.filter((_, i) => i !== index)); else if (links.length === 1) setLinks(['']); };
   const handleAvatarSelect = (avatarPath) => { setFormData(prev => ({ ...prev, avatar: avatarPath })); setAvatarPreviewUrl(avatarPath); setShowAvatarSelector(false); };

  // Функция сохранения профиля (без изменений в логике)
  const updateProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    // setSuccessMessage(''); // <-- Удаляем
    setSaveSuccess(false); // Сбрасываем перед новой попыткой
    try {
      const profileFormData = new FormData();
      profileFormData.append('telegram_id', telegramId);
      Object.keys(formData).forEach(key => {
        if (key !== 'avatar') {
          profileFormData.append(key, formData[key]);
        }
      });
      const linksToSave = links.filter(link => link && link.trim() !== '');
      profileFormData.append('links_json', JSON.stringify(linksToSave));
      if (linksToSave[0]) profileFormData.append('website', linksToSave[0]);
      if (linksToSave[1]) profileFormData.append('instagram', linksToSave[1]);
      if (formData.avatar) {
        let relativeAvatarPath = formData.avatar;
        if (relativeAvatarPath.startsWith(window.location.origin)) {
          relativeAvatarPath = relativeAvatarPath.substring(window.location.origin.length);
        }
        if (!relativeAvatarPath.startsWith('/')) {
          relativeAvatarPath = '/' + relativeAvatarPath;
        }
        if (relativeAvatarPath.match(/^\/avatars\/(\d{2}\.jpg|default-avatar\.png)$/)) {
          profileFormData.append('avatar_path', relativeAvatarPath);
          console.log("Отправка avatar_path:", relativeAvatarPath);
        } else {
          console.warn("Некорректный путь аватара, не отправляем:", formData.avatar);
        }
      } else {
        profileFormData.append('avatar_path', '');
        console.log("Аватар не выбран, отправляем пустой avatar_path.");
      }

      const response = await fetch(getApiUrl('/api/update_profile'), {
        method: 'POST',
        body: profileFormData
      });

      if (!response.ok) {
        let errorMsg = 'Не удалось обновить профиль';
        try {
          const errorData = await response.json();
          errorMsg = errorData.error || `Ошибка сервера: ${response.status}`;
        } catch (parseError) {
          console.error("Не JSON ошибка:", await response.text());
        }
        throw new Error(errorMsg);
      }

      const profileData = await response.json();
      console.log('Профиль обновлен:', profileData);
      // setSuccessMessage('Изменения сохранены'); // <-- Удаляем
      setSaveSuccess(true); // <-- Устанавливаем флаг успеха
      if (onProfileUpdated) {
        onProfileUpdated(profileData);
      }
      // setTimeout(() => setSuccessMessage(''), 2000); // <-- Удаляем
      setTimeout(() => setSaveSuccess(false), 2000); // <-- Сбрасываем флаг через 2 сек
    } catch (err) {
      console.error('Ошибка при обновлении профиля:', err.message);
      setError(err.message);
      setTimeout(() => setError(null), 5000);
    } finally {
      setLoading(false);
      // Не сбрасываем saveSuccess здесь, таймер сделает это
    }
  };

  // --- Рендер Компонента ---
  return (
    // Инлайн-стили для отмены фрейма
    <div
        className="profile-editor"
        style={{ backgroundColor: 'transparent', boxShadow: 'none', borderRadius: '0', padding: '20px', maxWidth: 'none', margin: '0', minHeight: 'unset' }}
    >
      <h1 style={{ textAlign: 'center', marginBottom: '25px' }}>Редактирование профиля</h1>

      {/* {successMessage && <div className="success-message"><p>{successMessage}</p></div>} */}{/* <-- Удаляем отображение successMessage */}
      {error && <div className="error-message"><p>⚠️ Ошибка: {error}</p></div>}

      <form onSubmit={updateProfile}>
        {/* Аватар */}
        <div style={{ marginBottom: '30px', textAlign: 'center' }}>
          <div
            className="avatar-preview"
            onClick={() => setShowAvatarSelector(!showAvatarSelector)} // <<< ВОССТАНОВЛЕН onClick
            title="Нажмите, чтобы изменить аватар"
          >
            <img
              key={avatarPreviewUrl}
              src={avatarPreviewUrl || '/avatars/default-avatar.png'}
              alt="Аватар"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              onError={(e) => {
                console.warn("Ошибка загрузки аватара (предпросмотр):", avatarPreviewUrl);
                e.target.onerror = null; e.target.src='/avatars/default-avatar.png';
                setAvatarPreviewUrl('/avatars/default-avatar.png');
                setFormData(prev => ({ ...prev, avatar: '/avatars/default-avatar.png' }));
              }}
            />
             <div className="avatar-overlay">Изменить</div>
          </div>
        </div>

        {/* --- Дубликат кнопки Сохранить --- */}
        <div style={{ marginBottom: '20px', textAlign: 'center' }}> {/* Добавляем отступ снизу и центрируем */}
          <button
            type="submit"
            disabled={loading || saveSuccess} // <-- Блокируем кнопку при загрузке и при показе успеха
            className="button button-primary save-profile-button" // <<< Используем тот же класс, что и у нижней кнопки
            // style убран, ширина будет определяться классом и родительским элементом
          >
            {loading ? 'Сохранение...' : saveSuccess ? 'Готово!' : 'Сохранить изменения'}{/* <-- Меняем текст кнопки */}
          </button>
        </div>
        {/* --- Конец дубликата кнопки --- */}

        {/* Выбор аватара */}
        {showAvatarSelector && (
          <div className="card" style={{ marginBottom: '30px' }}>
            <h3 style={{ marginBottom: '15px', textAlign: 'center' }}>Выберите аватар</h3>
             {loadingAvatars ? <div style={{ textAlign: 'center', padding: '20px' }}><p>Загрузка...</p></div>
             : errorAvatars ? <div className="error-message"><p>Ошибка загрузки аватаров: {errorAvatars}</p></div>
             : (
                 <div className="avatar-selector">
                     {presetAvatars.map((path, index) => (
                         <div
                             key={path}
                             className={`avatar-item ${formData.avatar === path ? 'selected' : ''}`}
                             onClick={() => handleAvatarSelect(path)}
                         >
                             <img src={path} alt={`Аватар ${index + 1}`}
                                 onError={(e) => { /* Обработка ошибки для маленьких аватаров */ }}/>
                         </div>
                     ))}
                 </div>
             )}
             {/* Кнопка "Закрыть выбор" удалена */}
          </div>
        )}

        {/* Основные поля */}
        <div className="form-group">
          <label htmlFor="name">Имя:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Ваше имя"
            className="form-input"
            maxLength={15}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '5px',
              border: '2px solid #E0E0E0'
            }}
          />
          <p className="character-count">{formData.name.length}/15 символов</p>
        </div>

        <div className="form-group" style={{ position: 'relative' }}>
            <label htmlFor="city">Город:</label>
            <input
                type="text"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                placeholder="Введите ваш город"
                className="form-input"
                maxLength={70}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: '2px solid #E0E0E0'
                }}
            />
            <p className="character-count">{formData.city.length}/70 символов</p>
        </div>

        <div className="form-group">
            <label htmlFor="bio">Теги:</label>
            <textarea 
                id="bio" 
                name="bio" 
                value={formData.bio} 
                onChange={handleInputChange} 
                rows="4" 
                maxLength={1000}
                placeholder="Теги - это слова, по которым будет работать поиск." 
                className="form-control"
            ></textarea>
            <p className="character-count">{formData.bio.length}/1000 символов</p>
        </div>



        {/*
        // ======================================================================= //
        // === НАЧАЛО ЗАКОММЕНТИРОВАННОГО БЛОКА С ДОПОЛНИТЕЛЬНЫМИ ПОЛЯМИ ПРОФИЛЯ === //
        // ======================================================================= //

        // Расширенные поля - используем form-control
        <div className="form-group"><label htmlFor="principles">Принципы и Мировоззрение:</label><textarea id="principles" name="principles" value={formData.principles} onChange={handleInputChange} rows="4" className="form-control" placeholder="Ваши ключевые ценности..."></textarea></div>
        <div className="form-group"><label htmlFor="interests">Интересы и Компетенции:</label><textarea id="interests" name="interests" value={formData.interests} onChange={handleInputChange} rows="4" className="form-control" placeholder="Области знаний, хобби..."></textarea></div>
        <div className="form-group"><label htmlFor="development">Вектор Развития:</label><textarea id="development" name="development" value={formData.development} onChange={handleInputChange} rows="4" className="form-control" placeholder="Навыки, знания, проекты..."></textarea></div>
        <div className="form-group"><label htmlFor="resources">Ресурсы для Взаимодействия:</label><textarea id="resources" name="resources" value={formData.resources} onChange={handleInputChange} rows="4" className="form-control" placeholder="Знания, опыт, навыки..."></textarea></div>
        <div className="form-group"><label htmlFor="contact_goals">Цели Контактов:</label><textarea id="contact_goals" name="contact_goals" value={formData.contact_goals} onChange={handleInputChange} rows="4" className="form-control" placeholder="Поиск партнеров, обмен мнениями..."></textarea></div>

        // ===================================================================== //
        // === КОНЕЦ ЗАКОММЕНТИРОВАННОГО БЛОКА С ДОПОЛНИТЕЛЬНЫМИ ПОЛЯМИ ПРОФИЛЯ === //
        // ===================================================================== //
        */}



        {/* Секция ссылок */}
         <div className="links-section">
           <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold' }}>Любые ссылки:</label>
           {links.map((link, index) => (
             <div key={index} className="link-input">
               <input
                 type="text"
                 value={link}
                 onChange={(e) => handleLinkChange(index, e.target.value)}
                 placeholder={`Ссылка ${index + 1} (напр., https://сайт.рф)`}
                 // Убрали className="form-control"
                 style={{ // <<< ДОБАВЛЯЕМ ИНЛАЙН СТИЛИ КАК У ПОЛЯ "ИМЯ"
                   width: '100%',
                   padding: '10px',
                   borderRadius: '5px', // <<< Радиус 5px
                   border: '2px solid #E0E0E0'
                 }}
               />
               {(links.length > 1 || link) && (
                   <button type="button" onClick={() => removeLinkField(index)} className="remove-link-button" title="Удалить ссылку">✕</button>
                )}
             </div>
           ))}
           {links.length < 5 && (
             <button
               type="button"
               onClick={addLinkField}
               className="button button-secondary add-link-button"
               style={{ borderRadius: '5px' }} // <<< ДОБАВЛЯЕМ ИНЛАЙН СТИЛЬ СКРУГЛЕНИЯ
             >
               + Добавить поле для ссылки
             </button>
           )}
         </div>

        {/* Кнопка Сохранить */}
        <button
          type="submit"
          disabled={loading || saveSuccess} // <-- Блокируем кнопку при загрузке и при показе успеха
          className="button button-primary save-profile-button"
        >
          {loading ? 'Сохранение...' : saveSuccess ? 'Готово!' : 'Сохранить изменения'}{/* <-- Меняем текст кнопки */}
        </button>

      </form>
    </div>
  );
};

export default ProfileEditor;